// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ReviewStep.css */

.edit-button {
    font-size: 12px;
}

.edit-button:hover {
    cursor: pointer;
}

.review-container {
  display: flex;
  gap: 1rem;
  align-items: stretch;
}

.review-panel-left {
  width: 70%;
}

.review-panel-right {
  width: 30%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.review-panel-top,
.review-panel-bottom {
  flex: 1 1;
}

.review-panel {
  border: 1px solid #e3e6ea;
  border-radius: 8px;
  padding: 1.25rem;
}

.review-panel-title {
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #8898aa;
  margin-bottom: 1rem;
}

.review-field {
  display: flex;
  flex-direction: column;
  margin-bottom: 0.85rem;
}

.review-field-label {
  font-size: 0.7rem;
  font-weight: 600;
  color: #8898aa;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0.15rem;
}

.review-field-value {
  font-size: 1rem;
  font-weight: 500;
  color: #32325d;
}

.review-field-empty {
  color: #c0c9d6;
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/views/pages/profile/Setup/css/ReviewStep.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAEnB;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,SAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB","sourcesContent":["/* ReviewStep.css */\r\n\r\n.edit-button {\r\n    font-size: 12px;\r\n}\r\n\r\n.edit-button:hover {\r\n    cursor: pointer;\r\n}\r\n\r\n.review-container {\r\n  display: flex;\r\n  gap: 1rem;\r\n  align-items: stretch;\r\n}\r\n\r\n.review-panel-left {\r\n  width: 70%;\r\n}\r\n\r\n.review-panel-right {\r\n  width: 30%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n}\r\n\r\n.review-panel-top,\r\n.review-panel-bottom {\r\n  flex: 1;\r\n}\r\n\r\n.review-panel {\r\n  border: 1px solid #e3e6ea;\r\n  border-radius: 8px;\r\n  padding: 1.25rem;\r\n}\r\n\r\n.review-panel-title {\r\n  font-size: 0.7rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.08em;\r\n  color: #8898aa;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.review-field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin-bottom: 0.85rem;\r\n}\r\n\r\n.review-field-label {\r\n  font-size: 0.7rem;\r\n  font-weight: 600;\r\n  color: #8898aa;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  margin-bottom: 0.15rem;\r\n}\r\n\r\n.review-field-value {\r\n  font-size: 1rem;\r\n  font-weight: 500;\r\n  color: #32325d;\r\n}\r\n\r\n.review-field-empty {\r\n  color: #c0c9d6;\r\n  font-style: italic;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
